export abstract class DbServiceBase {

    abstract getPubKeyForChat(chatId: string): string|null

    abstract setPublicKeyForUser(uid: string, pubKey: string): void

    abstract getCurrentImChatId(): string | null

    abstract setCurrentImChatChatId(chatId: string): void

    abstract setCurrentImChatUserId(userId: string): void

    abstract getCurrentImChatUserId(): string | null

}

class DbService extends DbServiceBase {

    setCurrentImChatUserId(userId: string | null): void {
        if (userId)
            localStorage.setItem('currentImChatUserId', userId)
    }
    getCurrentImChatUserId(): string | null {
        return localStorage.getItem('currentImChatUserId')
    }

    getCurrentImChatId(): string | null {
        return localStorage.getItem('currentImChatId')
    }
    setCurrentImChatChatId(chatId: string | null): void {
        if (chatId)
            localStorage.setItem('currentImChatId', chatId)
    }

    setPublicKeyForUser(uid: string, pubKey: string): void {
        localStorage.setItem(uid, pubKey)
    }

    getPubKeyForChat(uid: string): string|null {
        return localStorage.getItem(uid)
    }
}

export default new DbService()